<template>
  <div class="columns page-logs-tracking-event-header">
    <div class="column is-4">
      <sc-logs-tracking-detail-header-lote />
    </div>

    <div class="column is-4">
      <sc-logs-tracking-detail-header-event />
    </div>

    <div class="column is-4">
      <sc-logs-tracking-detail-header-order />
    </div>
  </div>
</template>

<script>
  import ScLogsTrackingDetailHeaderLote from './blocks/sc-logs-tracking-detail-header-lote/ScLogsTrackingDetailHeaderLote';
  import ScLogsTrackingDetailHeaderEvent from './blocks/sc-logs-tracking-detail-header-event/ScLogsTrackingDetailHeaderEvent';
  import ScLogsTrackingDetailHeaderOrder from './blocks/sc-logs-tracking-detail-header-order/ScLogsTrackingDetailHeaderOrder';

  export default {
    name: 'sc-logs-tracking-detail-header',
    components: {
      ScLogsTrackingDetailHeaderLote,
      ScLogsTrackingDetailHeaderEvent,
      ScLogsTrackingDetailHeaderOrder,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/pages/logs-tracking-detail/components/sc-logs-tracking-detail-header/ScLogsTrackingDetailHeader.vue